// src/components/common/Footer.tsx
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useLang } from '../../context/LangContext';

const FooterWrap = styled.footer`
  background: ${({ theme }) => theme.colors.cardBackground};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  padding: 20px 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.textLight};

  a {
    color: ${({ theme }) => theme.colors.textLight};
    text-decoration: none;
    &:hover {
      color: ${({ theme }) => theme.colors.primary};
      text-decoration: underline;
    }
  }
`;

const Rights = styled.span`
  margin-left: 4px;
`;

const Footer: React.FC = () => {
  const { t } = useLang();
  return (
    <FooterWrap>
      <Link to="/requisites">{t('footerRequisites')}</Link>
      <Link to="/offer">{t('footerOffer')}</Link>
      <Link to="/privacy">{t('footerConsent')}</Link>
      <a href="/instruction.pdf" target="_blank" rel="noopener noreferrer">{t('footerInstruction')}</a>
      <Rights>{t('footerRights')}</Rights>
    </FooterWrap>
  );
};

export default Footer;